import React from 'react';
import './style.scss';
import { identity } from '../../../utils/getIdentity';

const TextTag = ({ className, children }) => <span className={`text ${className}`}>{children}</span>;

const TEXT = {
  pageTitle({ color, ...rest }) {
    return <TextTag className={`text__page-title text__page-title-${identity}`} {...rest} />;
  },
  sectionTitle({ color, ...rest }) {
    return <TextTag className={`text__section-title text__section-title-${identity}`} {...rest} />;
  },
  sectionDescription({ color, ...rest }) {
    return <TextTag className={`text__section-description text__section-description-${identity}`} {...rest} />;
  },
  button({ color, ...rest }) {
    return <TextTag className="text__button" {...rest} />;
  },
  gray({ color, ...rest }) {
    return <TextTag className="text__gray" {...rest} />;
  },
  grayBold({ color, ...rest }) {
    return <TextTag className="text__gray-bold" {...rest} />;
  },
  grayBoldSmall({ color, ...rest }) {
    return <TextTag className="text__gray-bold-small" {...rest} />;
  },
  darkBold({ color, ...rest }) {
    return <TextTag className={`text__dark-bold text__dark-bold-${identity}`} {...rest} />;
  },
  label({ color, ...rest }) {
    return <TextTag className={`text__label text__label-${identity}`} {...rest} />;
  },
  darkBig({ color, ...rest }) {
    return <TextTag className={`text__dark-big text__dark-big-${identity}`} {...rest} />;
  },
};

export default TEXT;
